// For inline use in `app/views/account/onboarding/user_details/edit.html.erb`.
import jstz from "jstz";
window.jstz = require("jstz");
